import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';

export const initStateReferralGenerate = {
  referralGenerate: { data: null, loading: false, error: null },
};

export const referralGenerate = createAsyncThunk('tariff/referralGenerate', async (data, { rejectWithValue, fulfillWithValue }) => {
  const token = localStorage?.getItem('token');
  if (!token) rejectWithValue({ error: 'PROBLEM_WITH_TOKEN' });
  return await axios
    .post(
      `${process.env.REACT_APP_SERVER_API}/auth/profile/generate-referral-code/`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      console.log(res);
      return rejectWithValue(res.response.data);
    });
});

export const reducerReferralGenerate = {
  [referralGenerate.pending]: (state) => {
    state.referralGenerate.loading = true;
    state.referralGenerate.error = null;
  },
  [referralGenerate.fulfilled]: (state, action) => {
    state.referralGenerate.loading = false;
    state.referralGenerate.data = action.payload;
    state.referralGenerate.error = null;
  },
  [referralGenerate.rejected]: (state, action) => {
    state.referralGenerate.loading = false;
    state.referralGenerate.error = action.payload;
  },
};
